import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import { getUserByIdResponse, getAllUserResponse } from "../actions";

// Staff users are owned by Kriha Accounts; map its shape to the one the screens use.
const fromBackendUser = (u) =>
  u && {
    ...u,
    fullName: u.username ?? u.fullName,
    phoneNumber: u.mobileNumber ?? u.phoneNumber,
    role: typeof u.role === "string" ? u.role : "",
  };

const toBackendUser = (u = {}) => {
  const { fullName, phoneNumber, role, ...rest } = u;
  return {
    ...rest,
    username: fullName ?? rest.username,
    mobileNumber: phoneNumber != null ? String(phoneNumber) : rest.mobileNumber,
  };
};

export function* createUserEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosPost(`user`, toBackendUser(action.data?.payload)));
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "User added successfully.");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getUserByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`user/${action?.payload?.id}`));
    yield put(getUserByIdResponse(fromBackendUser(data)));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getUserByIdResponse([]));
  }
}

export function* getAllUserEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`user/all`));
    yield put(getAllUserResponse(Array.isArray(data) ? data.map(fromBackendUser) : data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllUserResponse([]));
  }
}

export function* updateUserEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(
        `user/${action?.data?.payload?.id}`,
        toBackendUser(action.data?.payload)
      )
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "User edited successfully.");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* deleteUserEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`user/3`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "User deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* userWatcherSaga() {
  yield takeLatest(types.CREATE_USER, createUserEffectSaga);
  yield takeLatest(types.GET_USER, getUserByIdEffectSaga);
  yield takeLatest(types.GET_ALL_USER, getAllUserEffectSaga);
  yield takeLatest(types.UPDATE_USER, updateUserEffectSaga);
  yield takeLatest(types.DELETE_USER, deleteUserEffectSaga);
}
